import React, { Component } from "react";
import withContext from "../withContext";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import axios from 'axios';

class PostStripe extends Component {

  componentDidMount(){
    document.body.style.paddingTop = "6em";
    window.scrollTo(0, 0);
    
    let web = window.location.href;
    let index = web.indexOf('success=true');
    let clean = this.props.context.clearCart;
    let clearBuyerData = this.props.context.clearBuyerData;

    if (index !== -1) {
        axios.get('/managingsuccess');
        clean();
        clearBuyerData();
      }
  }

  componentWillUnmount(){
    document.body.style.paddingTop = "0";
  }

  render() {
    let web = window.location.href;
    let index = web.indexOf('success=true');

  return (
    <Container className="mt-5 mb-5 text-center">
    {index !== -1 ? 
        (<>
          <Row className="justify-content-center mb-4">
            <Col md={8}>
              <img 
                src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExaGF3ZWRpbzBxaWlwNGJ0YzNqemJ3dmR4Y2xkOGh5ZnVqNnFicDduciZlcD12MV9naWZzX3NlYXJjaCZjdD1n/g9582DNuQppxC/giphy.gif" 
                alt="Celebration" 
                style={{maxWidth: '100%', height: 'auto', maxHeight: '300px', objectFit: 'contain'}}
              />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} id="firsttext">
              Thank you for your purchase! Your order will be sent within 3 working days. 
              <br/>Best regards, Kate!
            </Col>
          </Row>
        </>) : 
        (<Col md={{ span: 8, offset: 2 }} id="firsttext">
          :O Something gone wrong! <br/> Please, try again or contact me for futher support
        </Col>)
    }
        
    </Container>
  );
}};

export default withContext(PostStripe);